<template>
  <div class="d-flex align-items-center">
    <i class="gf-icon gf-icon-git-commit text-secondary mr-1" />

    <a
      class="text-truncate"
      :href="'/project/' + userAlias + '/' + projectAlias + '/commit/' + hash"
    >
      {{ hash | cutCommitHash }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'CommitShortLink',
  props: {
    hash: {
      default: null,
      type: String
    },
    userAlias: {
      default: null,
      type: String
    },
    projectAlias: {
      default: null,
      type: String
    }
  }
};
</script>
